import { v4 } from 'uuid';
import { UUID } from 'v2/core/entities/uuid';
import { NormalisedFilter } from 'v2/querybuilder/types/querystore';

interface getNewFilterNodeParams {
  parentID: UUID;
}

export function getNewFilterNode({
  parentID,
}: getNewFilterNodeParams): NormalisedFilter {
  return {
    id: v4(),
    field: '',
    operator: '',
    type: 'filter',
    parent: parentID,
    value: {
      type: 'string',
      value: '',
    },
  };
}
